export const durationUnits: Array<IOption> = [
  {value: 'day', label: 'روز'},
  {value: 'hour', label: 'ساعت'},
];
